module.exports = __webpack_public_path__ + "img/Message.72a03b93.svg";